import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Divider, useTheme } from '@mui/material';
import { useGetFootprintsQuery } from '../../state/api';
import moment from 'moment';
import Header from '../../components/Header';

const Footprints = () => {
    const theme = useTheme();
    const { data: footprintsResponse, isLoading, isError } = useGetFootprintsQuery();
  
    const footprints = footprintsResponse?.data;

    // Helper function to format action text
    const formatActionText = (action, target) => {
        const actionText = action.toLowerCase();
        const targetText = target.toLowerCase().replace(/_/g, ' ');
        
        switch (actionText) {
            case 'create':
                return `created a ${targetText}`;
            case 'update':
                return `updated a ${targetText}`;
            case 'delete':
                return `deleted a ${targetText}`;
            default:
                return `${actionText} a ${targetText}`;
        }
    };

    if (isLoading) return <Typography>Loading footprints...</Typography>;
    if (isError) return <Typography>Error loading footprints.</Typography>;

    return (
        <Box m="1.5rem 2.5rem">
            <Header title="Footprints" subtitle="Track and monitor all employee data changes and system activities." />
            <Paper sx={{ mt: 3, p: 2, backgroundColor: theme.palette.background.alt }}>
                <List>
                    {footprints && footprints.length > 0 ? footprints.map((footprint, index) => (
                        <React.Fragment key={footprint._id}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                    primary={
                                        <Typography variant="h6">
                                            {`${footprint.user?.name || 'Unknown User'} ${formatActionText(footprint.action, footprint.target)}`}
                                        </Typography>
                                    }
                                    secondary={
                                        <React.Fragment>
                                            <Typography component="span" variant="body2" color="text.primary">
                                                {moment(footprint.timestamp).format('YYYY-MM-DD HH:mm:ss')}
                                            </Typography>
                                            <Typography component="span" sx={{ display: 'block' }} variant="body2">
                                                {footprint.details.message}
                                            </Typography>
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                            {index < footprints.length - 1 && <Divider variant="inset" component="li" />}
                        </React.Fragment>
                    )) : (
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography variant="h6" textAlign="center" color="textSecondary">
                                        No footprints found
                                    </Typography>
                                }
                                secondary={
                                    <Typography variant="body2" textAlign="center" color="textSecondary">
                                        Employee activity will appear here when changes are made to the system.
                                    </Typography>
                                }
                            />
                        </ListItem>
                    )}
                </List>
            </Paper>
        </Box>
    );
};

export default Footprints; 